import { FaCheckCircle, FaUsers } from "react-icons/fa";
import Footerlanding from '../landing/Footerlanding';
import Navbarlanding from '../landing/Navbarlanding';

import "../css/ServiceNav.css"; // updated CSS file

const services = [
    { title: "Personal Loan", desc: "Quick approval for personal needs.", benefits: ["Minimal paperwork", "Flexible repayment"], interest: "10-15% p.a." },
    { title: "Home Loan", desc: "Easy home financing options.", benefits: ["Low down payment", "Long tenure"], interest: "7-12% p.a." },
    { title: "Car Loan", desc: "Low interest rates for your dream car.", benefits: ["Fast approval", "Affordable EMI"], interest: "8-13% p.a." },
    { title: "Business Loan", desc: "Flexible financing for your business.", benefits: ["Collateral-free options", "Quick disbursal"], interest: "9-16% p.a." },
    { title: "Education Loan", desc: "Fund your higher studies without stress.", benefits: ["Support for abroad studies", "Flexible repayment after graduation"], interest: "8-12% p.a." },
    { title: "Credit Card", desc: "Get rewards & cashback on your spending.", benefits: ["Reward points", "Exclusive offers"], interest: "Varies by card" },
    { title: "Insurance Plans", desc: "Protect yourself and your family.", benefits: ["Life & health coverage", "Affordable premiums"], interest: "NA" },
    { title: "Investment Plans", desc: "Grow your wealth smartly over time.", benefits: ["Mutual funds", "Stocks & ETFs"], interest: "Varies by investment" },
];

const ServicePage = () => {
    return (
        <div className="service-page-container">
            {/* Header / Navbar */}
            <Navbarlanding />

            {/* Hero Section */}
            <section className="service-hero">
                <div className="hero-inner">
                    <div className="hero-left">
                        <h1>Discover Our Financial Solutions</h1>
                        <p>Your dedicated team helping you achieve financial freedom.</p>
                        <button className="btn-primary">Contact Us</button>
                        <div className="social-proof">
                            <FaUsers className="icon" />
                            <span>More than 10k active users 🚀</span>
                        </div>
                    </div>
                    <div className="hero-right">
                        <img
                            src="https://cdn-icons-png.flaticon.com/512/4140/4140048.png"
                            alt="Financial Solutions"
                        />
                    </div>
                </div>
            </section>

            {/* Services Grid */}
            <section className="services-grid">
                <h2 className="services-title">Our Services</h2>
                <div className="services-inner">
                    {services.map((service, index) => (
                        <div key={index} className="service-card enhanced-card">
                            <FaCheckCircle className="card-icon" />
                            <h3>{service.title}</h3>
                            <p>{service.desc}</p>
                            <ul className="service-benefits">
                                {service.benefits.map((benefit, i) => (
                                    <li key={i}>✅ {benefit}</li>
                                ))}
                            </ul>
                            {service.interest && <p className="service-interest"><strong>Interest / Rate:</strong> {service.interest}</p>}
                            <a href="#" className="know-more">
                                Know more →
                            </a>
                        </div>
                    ))}
                </div>
            </section>

            {/* CTA Section */}
            <section className="cta-section">
                <div className="cta-inner">
                    <h2>Ready to secure your financial future?</h2>
                    <p>Join us today and take the first step towards financial freedom.</p>
                    <button className="btn-primary">Get started today</button>
                </div>
            </section>

            {/* FAQ Section */}
            <section className="faq-section">
                <div className="faq-inner">
                    <h2>You have questions, we have answers</h2>
                    <div className="faq-card">
                        <select>
                            <option>What types of loans do you offer?</option>
                            <option>How can I apply for a loan?</option>
                            <option>What documents are required?</option>
                            <option>How fast is the approval process?</option>
                        </select>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <Footerlanding />
        </div>
    );
};

export default ServicePage;